/**
 * Thai Business Suite — Web Bundle
 * Enhances all public website pages with branding, animations, and dynamic site context.
 * Injected via web_include_js in hooks.py.
 */
(function () {
	"use strict";

	if (window.__tbs_web_loaded) return;
	window.__tbs_web_loaded = true;

	// ── Helpers ──────────────────────────────────────────────
	function ready(fn) {
		if (document.readyState !== "loading") fn();
		else document.addEventListener("DOMContentLoaded", fn);
	}

	function getSiteName() {
		// Try frappe boot data first, then extract from host
		if (window.frappe && frappe.boot && frappe.boot.sitename) {
			return frappe.boot.sitename;
		}
		var host = window.location.hostname;
		// Strip common suffixes for display
		return host
			.replace(/\.localhost$/, "")
			.replace(/\.local$/, "")
			.replace(/\.frappe\.cloud$/, "")
			.replace(/^www\./, "");
	}

	function getBrandName() {
		if (window.frappe && frappe.boot && frappe.boot.website_settings) {
			return (
				frappe.boot.website_settings.app_name ||
				frappe.boot.website_settings.brand_html ||
				""
			);
		}
		return "";
	}

	// ── Scroll-Reveal Observer ──────────────────────────────
	function initScrollReveal() {
		if (!("IntersectionObserver" in window)) return;
		if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

		var observer = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						entry.target.classList.add("tbs-web-revealed");
						observer.unobserve(entry.target);
					}
				});
			},
			{ threshold: 0.15, rootMargin: "0px 0px -40px 0px" },
		);

		document.querySelectorAll(".tbs-web-reveal").forEach(function (el) {
			observer.observe(el);
		});
	}

	// ── Thai Pattern Watermark ──────────────────────────────
	function injectThaiWatermark() {
		var wrapper =
			document.querySelector(".web-footer") ||
			document.querySelector("footer");
		if (!wrapper) return;

		// Only inject once
		if (document.getElementById("tbs-web-thai-motif")) return;

		var motif = document.createElement("div");
		motif.id = "tbs-web-thai-motif";
		motif.setAttribute("aria-hidden", "true");
		wrapper.style.position = "relative";
		wrapper.style.overflow = "hidden";
		wrapper.insertBefore(motif, wrapper.firstChild);
	}

	// ── Footer Enhancement ──────────────────────────────────
	function enhanceFooter() {
		var footer =
			document.querySelector(".web-footer .text-left > div") ||
			document.querySelector(".web-footer .text-left") ||
			document.querySelector(".web-footer .footer-col-left") ||
			document.querySelector(".web-footer .footer-powered") ||
			document.querySelector(".web-footer");
		if (!footer) return;

		// Add class to inner div if missing
		if (!footer.className || !footer.className.includes("footer-logo-wrapper")) {
			footer.classList.add("footer-logo-wrapper");
		}

		var siteName = getSiteName();
		var brandName = getBrandName();
		var displayName = brandName || siteName;
		var year = new Date().getFullYear();

		// Add site branding if not already branded
		if (
			!footer.querySelector(".tbs-web-footer-brand") &&
			displayName &&
			displayName !== "localhost"
		) {
			var brand = document.createElement("div");
			brand.className = "tbs-web-footer-brand";
			brand.innerHTML =
				'<span id="tbs-web-footer-url" aria-hidden="true"></span> ' +
				displayName +
				" &middot; " +
				year;
			footer.appendChild(brand);
		}
	}

	// ── Page Entrance Animation ─────────────────────────────
	function initPageEntrance() {
		if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

		document.body.classList.add("tbs-web-entering");
		requestAnimationFrame(function () {
			requestAnimationFrame(function () {
				document.body.classList.remove("tbs-web-entering");
				document.body.classList.add("tbs-web-entered");
			});
		});
	}

	// ── Login Page Enhancement ──────────────────────────────
	function enhanceLoginPage() {
		if (window.location.pathname !== "/login") return;

		var loginBox =
			document.querySelector(".login-content") ||
			document.querySelector(".page-card");
		if (!loginBox) return;

		loginBox.classList.add("tbs-web-login-enhanced");

		var siteName = getSiteName();
		if (
			siteName &&
			siteName !== "localhost" &&
			!document.querySelector(".tbs-web-login-site-name")
		) {
			var siteLabel = document.createElement("div");
			siteLabel.className = "tbs-web-login-site-name";
			siteLabel.textContent = siteName;
			loginBox.insertBefore(siteLabel, loginBox.firstChild);
		}
	}

	// ── Navbar Scroll Shadow ────────────────────────────────
	function initNavbarScroll() {
		var navbar = document.querySelector(".navbar");
		if (!navbar) return;

		var ticking = false;
		window.addEventListener(
			"scroll",
			function () {
				if (!ticking) {
					requestAnimationFrame(function () {
						if (window.scrollY > 20) {
							navbar.classList.add("tbs-web-navbar-scrolled");
						} else {
							navbar.classList.remove("tbs-web-navbar-scrolled");
						}
						ticking = false;
					});
					ticking = true;
				}
			},
			{ passive: true },
		);
	}

	// ── Init ────────────────────────────────────────────────
	ready(function () {
		document.documentElement.classList.add("tbs-web-active");
		initPageEntrance();
		initNavbarScroll();
		initScrollReveal();
		injectThaiWatermark();
		enhanceFooter();
		enhanceLoginPage();
	});
})();
